import PropTypes from 'prop-types';

import { completeName } from 'helpers/name';

import Bookmark from '../components/Bookmark';
import AliveUserInfo from '../components/AliveUserInfo';
import DeadUserInfo from '../components/DeadUserInfo';

const Card = ({ user, onDeleteBookmark }) => (
  <div
    className="grid__item one-half palm--one-whole push-half--bottom item-ressource-view"
    data-item-id={user.id}
  >
    <div className="relative card-item flex">
      {AlumniConnect.currentNetwork.get('network_config')
        .user_bookmarks_enabled &&
        AlumniConnect.currentUser.id != user.id && (
          <Bookmark user={user} onChange={onDeleteBookmark} />
        )}

      <a href={Routes.user_path(user.id)} className="js-show-on-map">
        {user.deceased && (
          <div className="deceased-wrapper">
            <div className="corner" />
          </div>
        )}

        <div className="flexbox__item card-user-view__picture">
          <img className="block" src={user.photo_url} />
        </div>

        <div className="flexbox__item soft-half v-top">
          <div className="card-user-view__username color-dark-gray weight--semibold">
            {completeName(user)}
            {user.maidenname && (
              <span className="color-gray push-quarter--left">
                ({user.maidenname})
              </span>
            )}
          </div>

          {user.deceased ? (
            <DeadUserInfo user={user} />
          ) : (
            <AliveUserInfo user={user} />
          )}
        </div>
      </a>
    </div>
  </div>
);

Card.propTypes = {
  onDeleteBookmark: PropTypes.func,
};

export default Card;
